import { PolymorphicComponentProps } from "@omni/types/components/utils/polymorphic.types";
import React from "react";

import { card } from "../../card.style";

export type CardTextComponentProps = {};

export type CardHeaderProps<T extends React.ElementType> =
    PolymorphicComponentProps<T, CardTextComponentProps, "div">;

const CardText = <T extends React.ElementType = "div">({
    className,
    tag,
    ...attributes
}: CardHeaderProps<T>) => {
    const Tag = tag || ("div" as React.ElementType);
    const { text } = card({});

    return (
        <Tag
            {...attributes}
            className={text({ className })}
        />
    );
};

export { CardText };
